(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["linko-model-quiz"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-linko-quiz]');
  if (!root) return;
  var cfgNode = document.querySelector('[data-linko-quiz-config]');
  var config = {};
  try {
    config = JSON.parse(cfgNode.textContent);
  } catch (e) {
    config = {};
  }

  function show(name) {
    root.querySelectorAll('[data-step]').forEach(function (el) {
      el.hidden = el.getAttribute('data-step') !== name;
    });
  }

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderProduct(product) {
    var img = product.image
      ? '<img class="linko-quiz__product-img" src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="400" height="400">'
      : '<div class="linko-quiz__product-img linko-quiz__product-img--empty"></div>';
    return (
      '<a class="linko-quiz__product" href="' + escapeHtml(product.url) + '">' +
      img +
      '<span class="linko-quiz__product-body">' +
      '<span class="linko-quiz__product-title">' + escapeHtml(product.title) + '</span>' +
      '<span class="linko-quiz__product-price">' + escapeHtml(product.price) + '</span>' +
      '</span></a>'
    );
  }

  function renderLink(link) {
    return '<a class="linko-quiz__card" href="' + escapeHtml(link.url) + '"><span>' + escapeHtml(link.label) + '</span></a>';
  }

  function renderResult(key) {
    var box = root.querySelector('[data-results]');
    if (!box) return;
    var outcome = config[key] || {};
    var products = outcome.products || [];
    var links = outcome.links || [];
    var html = '';

    if (products.length) {
      html += '<div class="linko-quiz__products">' + products.map(renderProduct).join('') + '</div>';
    } else {
      html += links
        .filter(function (link) {
          return link.type !== 'whatsapp';
        })
        .map(renderLink)
        .join('');
    }

    html += links
      .filter(function (link) {
        return link.type === 'whatsapp';
      })
      .map(renderLink)
      .join('');

    box.innerHTML = html;
    show('result');
  }

  root.addEventListener('click', function (event) {
    var btn = event.target.closest('button');
    if (!btn || !root.contains(btn)) return;
    if (btn.hasAttribute('data-reset')) {
      show('category');
      return;
    }
    if (btn.dataset.next) {
      show(btn.dataset.next);
      return;
    }
    if (btn.dataset.go) {
      show(btn.dataset.go);
      return;
    }
    if (btn.dataset.result) renderResult(btn.dataset.result);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
